import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './achievement.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { Achievement } from "model/product/achievement.model";

export interface AchievementDetailsProps extends DetailsStateAndDispatchProps<Achievement>,
  RouteComponentProps, StateProps, DispatchProps {
}
const AchievementDetails: FC<AchievementDetailsProps> = (props) => {
  return (
    <DetailsPage<Achievement>
      title={'商品业绩模版详情'}
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<Achievement>
        columns={props.columns as any}
        dataSource={props.entity}
        column={2}
      >
      </ProDescriptions>

    </DetailsPage>);
};

const mapStateToProps = ({ achievement }: RootState) => ({
  entity: achievement.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(AchievementDetails);
